import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { RegistrationDetailsFormDataCustomer } from '@/common/viewModels/registrationDetails/form/data/RegistrationDetailsFormDataCustomer';
import { RegistrationsDetailsFormStateCustomer } from '@/common/viewModels/registrationDetails/form/state/RegistrationDetailsFormStateCustomer';

@Component({
  components: {
  },
})
export default class RegistrationDetailsEditCustomer extends Vue {
  @Prop({ required: true }) data!: RegistrationDetailsFormDataCustomer;
  @Prop({ required: true }) state!: RegistrationsDetailsFormStateCustomer;
  @Prop() testing!: boolean;

  mounted(): void {
    this._initialiseVForm();
  }

  @Emit()
  formInputChange(inputEvent: any) {
    const target: any = inputEvent.target;
    this.$emit('formInputChange', target.name, target.value);
  }

  private _initialiseVForm() {
    if (this.testing !== true) {
      (this.$refs.vForm as any).validate();
    }
  }
}
